/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @date    15/4/19
 * @since   1.0.0
 *
 * @param   object $block The block jQuery element.
 * @param   object attributes The block attributes (only available when editing).
 * @return  void
 */
var initializeBlock = function ( $block, $index ) {

    const slider = $block.find('.before-and-after-slider');
    const before = $block.find('.before-image');
    const beforeImage = before.find('img')[0];
    const resizer = $block.find('.resizer');

    let active = false;
    let documentWidth = $(window).width();
    let documentHeight = $(window).height();

    //Sort overflow out for Overlay Image
    let width = slider.width();
    beforeImage.style.maskSize = width + 'px';

    //Adjust width of image on resize
    window.addEventListener('resize', function () {

        if ($(window).width() !== documentWidth || $(window).height() !== documentHeight) {
            let width = slider.width();
            beforeImage.style.maskSize = width + 'px';
        }
    })

    resizer.on('mousedown',function () {
        active = true;
        resizer.classList.add('resize');
    });

  $block.on('mouseup',function () {
        active = false;
        resizer.removeClass('resize');
    });

  $block.on('mouseleave', function () {
        active = false;
        resizer.removeClass('resize');
    });

    $block.on('mousemove',function (e) {
        if (!active) {
            return;
        }

        let x = e.pageX;
        x -= slider[0].getBoundingClientRect().left;
        slideIt(x);
        pauseEvent(e);
    });

    resizer.on('touchstart',function () {
        active = true;
        resizer.addClass('resize');
    });

    $block.on('touchend',function () {
        active = false;
        resizer.removeClass('resize');
    });

    $block.on('touchcancel',function () {
        active = false;
        resizer.removeClass('resize');
    });

    $block.on('touchmove',function (e) {
        if (!active) {
            return;
        }

        let x;

        let i;
        for (i = 0; i < e.changedTouches.length; i++) {
            x = e.changedTouches[i].pageX;
        }

        x -= slider[0].getBoundingClientRect().left;
        slideIt(x);
        pauseEvent(e);
    });

    function slideIt(x)
    {
        let transform = Math.max(0,(Math.min(x,slider.width())));
        beforeImage.style.maskSize = x * 2 + "px";
        resizer[0].style.left = transform + "px";
    }

//stop divs being selected.
    function pauseEvent(e)
    {
        if (e.stopPropagation) {
            e.stopPropagation();
        }
        if (e.preventDefault) {
            e.preventDefault();
        }
        e.cancelBubble = true;
        e.returnValue = false;
        return false;
    }



}

// Initialize each block on page load (front end).
$(function () {
    $('.before-and-after-slider-block').each(function (index, element) {
        $(this).addClass('s' + index);
        initializeBlock($(this), index);
    });
});

// Initialize dynamic block preview (editor).
if ( window.acf ) {
    window.acf.addAction('render_block_preview/type=before-and-after-slider-block', initializeBlock);
}
